import { _Angle___get_turns__impl__atdtw5dv920nekm6fo as _Angle___get_turns__impl__atdtw5 } from '../../../../kiteui-library/com/lightningkite/kiteui/models/Angle.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { NotImplementedErrorfzlkpv14xxr8 as NotImplementedError } from '../../../../kotlin-kotlin-stdlib/kotlin/Standard.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function set_rotation(_this__u8e3s4, value) {
  var tmp0 = _this__u8e3s4.vb5_1.db4_1;
  // Inline function 'com.lightningkite.kiteui.views.transform' call
  var value_0 = 'rotate(' + _Angle___get_turns__impl__atdtw5(value) + 'turn)';
  tmp0.hb7_1.transform = value_0;
}
function get_rotation(_this__u8e3s4) {
  throw NotImplementedError().qd();
}
//region block: exports
export {
  get_rotation as get_rotation2o00xy9g08m4u,
  set_rotation as set_rotationrdhjwh8aps06,
};
//endregion

//# sourceMappingURL=rotation.mjs.map
